<template>
  <div class="login-form">
    <section class="hero is-light is-bold">
      <div class="hero-body">
        <div class="container">
          <p class="title">
            <vue-typed-js
              :strings="['KYC Forms', 'Know Your Client Forms' ,'Know Your Client']"
              :typeSpeed="100"
              :backSpeed="100"
              :backDelay="150"
            >
              <h3><span class="typing"></span></h3>
            </vue-typed-js>
          </p>
        </div>
      </div>
    </section>

    <section class="hero">
      <div class="hero-body">
        <div class="container is-fluid login-box">
          <section v-if="!token">
            <b-field label="Email" position="is-centered">
              <b-input type="email"
                name="email"
                v-focus
                v-model="email"
                @keyup.native.enter="resetPassword"
              />
            </b-field>
            <b-field position="is-centered">
              <button class="button is-primary is-outlined" type="submit" @click="resetPassword">Reset password</button>
            </b-field>
          </section>
         <section v-else>
            <b-field label="New password" position="is-centered">
              <b-input type="password"
                name="password"
                v-focus
                v-model="password"
                password-reveal
              />
            </b-field>
            <b-field label="Confirm password" position="is-centered">
              <b-input type="password"
                name="passwordConfirm"
                v-model="passwordConfirm"
                password-reveal
                @keyup.native.enter="updatePassword"
              />
            </b-field>
            <b-field position="is-centered">
              <button class="button is-primary is-outlined" type="submit" @click="updatePassword">Reset password</button>
            </b-field>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import jwt from 'jwt-simple'

export default {
  name: 'ResetPasswordForm',
  data () {
    return {
      email: null,
      token: null,
      password: null,
      passwordConfirm: null
    }
  },
  created () {
    this.token = this.$route.query.u
    if (this.token) {
      const decoded = jwt.decode(this.token, null, true)
      if (decoded.exp < (new Date()).getTime() / 1000) {
        this.$toast.open({
          message: 'Link expired',
          type: 'is-warning'
        })
        this.$router.replace({name: 'main'})
      }
    }
  },
  mounted () {
    if (this.$auth.check()) {
      this.$router.replace({name: 'main'})
    }
  },
  methods: {
    resetPassword () {
      console.log('resetPassword')
      this.axios.post('/account/reset', { email: this.email })
        .then(response => {
          console.log(response)
          this.$toast.open({
            message: 'Password reset link sent to your email',
            type: 'is-success'
          })
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: 'Error',
            type: 'is-danger'
          })
        })
        .finally(_ => {
          this.$router.replace({name: 'main'})
        })
    },
    updatePassword () {
      if (this.password !== this.passwordConfirm) {
        this.$toast.open({
          message: 'Passwords doesn\'t match',
          type: 'is-danger'
        })
        return
      }
      this.axios.put(`account/reset/${this.token}`, { password: this.password })
        .then(response => {
          let toastType = 'is-success'
          if (response.data.Error) toastType = 'is-danger'
          this.$toast.open({
            message: response.data.msg,
            type: toastType
          })
          this.$router.replace({name: 'main'})
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: error.response.data.msg,
            type: 'is-danger'
          })
        })
    }
  }
}
</script>

<style scoped>
.login-box {
  margin: auto;
  max-width: 400px;
}
</style>
